var _defs, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgress4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    fill: "none",
    viewBox: "0 0 86 86"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 43,
    r: 43,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M27.1 41L23 45l14.35 14L64 33l-4.1-4-22.55 22L27.1 41z"
  })));
}
export default SvgProgress4;